import { NavLink } from 'react-router-dom';

export default function SoMSubNav() {
  const item = ({ isActive }) =>
    `px-3 py-1.5 text-sm rounded-md transition-colors duration-200 ${
      isActive
        ? 'bg-[var(--accent-light)] text-[var(--accent)]'
        : 'text-[var(--text-secondary)] hover:text-[var(--text-primary)] hover:bg-[var(--canvas-tertiary)]'
    }`;

  return (
    <nav className="flex items-center gap-1" data-testid="som-subnav">
      <NavLink to="/som" end className={item} data-testid="som-subnav-overview">
        Overview
      </NavLink>
      <NavLink to="/som/prompts" className={item} data-testid="som-subnav-prompts">
        Prompts
      </NavLink>
      <NavLink to="/som/history" className={item} data-testid="som-subnav-history">
        History
      </NavLink>
      <NavLink to="/som/usage" className={item} data-testid="som-subnav-usage">
        Usage
      </NavLink>
    </nav>
  );
}
